import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { FaWhatsapp, FaPhoneAlt } from 'react-icons/fa';
import LandingPage from './Pages/LandingPage';
import Navbar from './Components/NavBar';
import AboutUs from './Pages/AboutUs';
import Footer from './Components/Footer';
import Services from './Pages/Services';
import PackagesAndPricing from './Pages/PackagesAndPricing';
import ContactUs from './Pages/ContactUs';

// === BEGIN FloatingIcons COMPONENT ===

// Phone configuration
const PHONE_NUMBER = "+917065070650";
const PHONE_DISPLAY = "+91 7065070650";
const customRed = "#FF244D";

function FloatingIcons() {
  // Call configuration
  const callHref = `tel:${PHONE_NUMBER}`;

  // Whatsapp message encode
  const whatsappMessage = encodeURIComponent(
    "Hello, I am interested in booking a test or package at Dr. Sangeet Diagnostics. Please share available tests, health packages, and details."
  );
  const whatsappHrefWithMsg = `https://wa.me/${PHONE_NUMBER.replace("+", "")}?text=${whatsappMessage}`;

  return (
    <>
      {/* Floating WhatsApp Icon Left */}
      <a
        href={whatsappHrefWithMsg}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed left-4 bottom-10 z-[100] flex items-center justify-center rounded-full shadow-lg"
        style={{
          backgroundColor: "#25D366",
          color: "#fff",
          width: 56,
          height: 56,
          fontSize: 30,
          boxShadow:
            "0 5px 30px rgba(40,200,100,0.20), 0 2px 6px rgba(0,0,0,0.10)",
          transition: "transform 0.12s",
        }}
        aria-label="WhatsApp"
        tabIndex={0}
      >
        <FaWhatsapp />
      </a>

      {/* Floating Call Icon Right */}
      <a
        href={callHref}
        className="fixed right-4 bottom-10 z-[100] flex items-center justify-center rounded-full shadow-lg"
        style={{
          backgroundColor: customRed,
          color: "#fff",
          width: 56,
          height: 56,
          fontSize: 26,
          boxShadow:
            "0 5px 30px rgba(255,36,77,0.18), 0 2px 6px rgba(0,0,0,0.09)",
          transition: "transform 0.12s",
        }}
        aria-label={`Call ${PHONE_DISPLAY}`}
        tabIndex={0}
      >
        <FaPhoneAlt />
      </a>
      {/* Optionally, add a small media query for mobile so they don't block other actions */}
      <style>{`
        @media (max-width: 500px) {
          .floating-contact-mobile-hide {
            display: none !important;
          }
          /* Slightly higher on very small screens */
          .fixed.left-4.bottom-10, .fixed.right-4.bottom-10 {
            bottom: 18px !important;
          }
        }
        .fixed.left-4.bottom-10:hover, .fixed.right-4.bottom-10:hover {
          transform: scale(1.10) translateY(-4px);
          filter: brightness(1.1);
        }
      `}</style>
    </>
  );
}

// === END FloatingIcons COMPONENT ===

const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutUs  />} />
        <Route path="/services" element={<Services />} />
        <Route path="/pricing" element={<PackagesAndPricing />} />
        <Route path="/contact" element={<ContactUs />} />
      </Routes>
      <Footer />
      <FloatingIcons />
    </Router>
  );
};

export default App;
